import { render } from "./TradeIndicatorsList.vue?vue&type=template&id=794f5cb6&scoped=true"
import script from "./TradeIndicatorsList.vue?vue&type=script&lang=js"
export * from "./TradeIndicatorsList.vue?vue&type=script&lang=js"

import "./TradeIndicatorsList.vue?vue&type=style&index=0&id=794f5cb6&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-794f5cb6"]])

export default __exports__